//@flow
import type { AddressType } from 'digicel-kaizen-library';

export type DeliveryAddressActionType =
  | {|
      type: 'SIGNUP_SET_DELIVERY_ADDRESS',
      payload: {|
        deliveryAddress: AddressType,
      |},
    |}
  | {|
      type: 'SIGNUP_SET_DELIVERY_INSTRUCTION',
      payload: {|
        deliveryInstruction: string,
      |},
    |}
  | {|
      type: 'CONFIRM_DELIVERY_ADDRESS',
      payload: {|
        deliveryAddress: AddressType,
      |},
    |};

export function setDeliveryAddress(deliveryAddress: AddressType): DeliveryAddressActionType {
  return {
    type: 'SIGNUP_SET_DELIVERY_ADDRESS',
    payload: {
      deliveryAddress,
    },
  };
}

export const setDeliveryInstruction = (deliveryInstruction: string) => ({
  type: 'SIGNUP_SET_DELIVERY_INSTRUCTION',
  payload: {
    deliveryInstruction,
  },
});

export function confirmDeliveryAddress(deliveryAddress: AddressType): DeliveryAddressActionType {
  return {
    type: 'CONFIRM_DELIVERY_ADDRESS',
    payload: {
      deliveryAddress,
    },
  };
}
